import React from 'react';
import { Typography } from '@mui/material';

interface ICasLink {
  onClick: VoidFunction;
  children: React.ReactNode;
  color?: string;
}

const isEmpty = (children: React.ReactNode) =>
  children === null ||
  children === undefined ||
  (typeof children === 'string' && children.trim() === '');

export default function CasLink({ onClick, children, color = 'primary.main' }: ICasLink) {
  return (
    <Typography
      sx={{ fontSize: 'inherit', cursor: 'pointer', color }}
      onClick={onClick}
      component="span"
    >
      {isEmpty(children) ? <i>(empty)</i> : children}
    </Typography>
  );
}
